import React, {ReactNode} from 'react';
import cn from 'classnames';

import styles from './TariffLimitRow.module.scss';

interface ITariffLimitRowProps {
    value: ReactNode;
    label: string;
    className?: string;
}

const TariffLimitRow: React.FC<ITariffLimitRowProps> = ({value, label, className}) => (
    <div className={cn(styles.container, className)}>
        <span className={styles.label}>{label}</span>
        <div className={styles.value}>{value}</div>
    </div>
);

export default TariffLimitRow;
